import { type AccountInfo, PublicClientApplication } from "@azure/msal-browser";
import { reactive } from "vue";

export const msalConfig = {
    auth: {
        clientId: import.meta.env.VITE_CLIENT_ID as string,
        authority: `https://login.microsoftonline.com/${import.meta.env.VITE_TENANT_ID}`,
        redirectUri: import.meta.env.VITE_REDIRECT_URI,
        postLogoutUri: window.location.origin,
        navigateToLoginRequestUrl: false
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false
    }
}

export const state = reactive({
    isAuthenticated: false,
    user: null as AccountInfo | null,
})

export const msal = new PublicClientApplication(msalConfig)